import { component$, $, type PropsOf, Slot } from "@builder.io/qwik";
import { cn } from "~/lib/cn";

export const Checkbox = component$<Omit<PropsOf<"input">, "children">>(
  ({ id, name, ["bind:checked"]: checkedSig, checked, onInput$, ...props }) => {
    const isChecked = checkedSig ? checkedSig.value : checked;
    const inputId = id || name;

    return (
      <label
        class={cn(
          "group flex cursor-pointer items-start justify-stretch gap-2 text-sm font-medium leading-4",
          { "cursor-not-allowed opacity-70": props.disabled },
        )}
      >
        <input
          type="checkbox"
          id={inputId}
          name={name}
          checked={isChecked}
          onInput$={
            checkedSig
              ? $((_, el: HTMLInputElement) => (checkedSig.value = el.checked))
              : onInput$
          }
          class="sr-only"
          {...props}
        />
        <div
          class={cn(
            "peer size-4 shrink-0 rounded-sm border transition-colors duration-200",
            "flex items-center justify-center",
            {
              "border-brand-700 bg-brand-50 group-hover:border-brand-500 group-hover:bg-transparent":
                isChecked && !props.disabled,
              "group-hover:border-brand-700 group-hover:bg-brand-50 border-gray-200 bg-transparent":
                !isChecked && !props.disabled,
              "ring-ring text-brand-700 group-hover:text-brand-500 group-focus:outline-none group-focus:ring group-active:ring":
                !props.disabled,
            },
            props.class,
          )}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isChecked && (
              <path
                d="M8.33317 2.5L3.74984 7.08333L1.6665 5"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            )}
          </svg>
        </div>
        <div class="flex w-full grow flex-col items-stretch gap-1">
          <Slot />
        </div>
      </label>
    );
  },
);
